var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FontAwesomeIcon',{staticClass:"icon",attrs:{"icon":[_vm.solid ? 'fas' : 'far', _vm.name],"size":_vm.availableSizes[_vm.size]}})}
var staticRenderFns = []

export { render, staticRenderFns }